export default __webpack_public_path__ + "static/media/1948.db50e9bf.png";